import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import WarningIcon from '@bufferapp/ui/Icon/Icons/Warning'

import { Composer } from '~/modules/composer/components'
import {
  Attachment,
  AvatarDefault,
  Label,
  TextPlaceholder,
} from '~/shared/components'
import { CommentToggle } from '~/modules/post/components'
import { ChannelAvatar } from '~/modules/channel/components'
import { COMMENT_STATUS } from '~/modules/post/constants'
import { URL_ACCOUNT_CHANNELS } from '~/modules/channel/constants'
import {
  ERROR_SEND_COMMENT_DELETED,
  ERROR_SEND_PERMISSON,
  ERROR_TARGET_USER_MENTION,
  SERVICE_DEFAULTS,
} from '~/app/constants'

import {
  AvatarWrapper,
  Column,
  CommentInfo,
  CommentWrapper,
  ComposerWrapper,
  ContentWrapper,
  ErrorCTA,
  ErrorIconWrapper,
  ErrorWrapper,
  Labels,
  RepliesWrapper,
  Row,
  ShowReplies,
  ShowRepliesDecoration,
  Status,
  StyledText,
  TimeAgo,
  ToggleWrapper,
  Username,
  Wrapper,
} from './styles'

import { formatTimeAgo } from '~/modules/post/utils'

export const ERROR_REPLY = 'Reply failed. Click to retry.'
export const ERROR_DISMISS = 'Dismiss comment failed.'
export const ERROR_PERMISSION = 'Reply failed, please reconnect the channel'
export const ERROR_MENTION =
  "Tagged user doesn't exist or doesn't accept mentions. Remove the tag and try again."

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'comment' implicitly has an 'any' type.
function getCommentStatus(comment, selected, service) {
  const { needsAttention, error, status } = comment || {}

  // NOTE: We'll come back to refactor this as part of EN-194.
  // We should rely on the comment status for "Comment deleted on <Service>"
  // and "Engaged".

  if (error && error.code === ERROR_SEND_COMMENT_DELETED) {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return `Comment deleted on ${SERVICE_DEFAULTS[service].label}`
  }

  if (status === COMMENT_STATUS.SENDING) {
    return status
  }

  if (!needsAttention) {
    return 'Engaged'
  }

  if (selected) {
    return 'Replying...'
  }

  return 'Reply'
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'error' implicitly has an 'any' ty... Remove this comment to see the full error message
const Error = ({ error }) => {
  const { type, draft, code } = error

  const isPermissionError = code === ERROR_SEND_PERMISSON
  const isMentionError = code === ERROR_TARGET_USER_MENTION

  let message = null

  if (type === 'dismiss') {
    message = ERROR_DISMISS
  } else {
    if (isPermissionError) {
      message = ERROR_PERMISSION
    } else if (isMentionError) {
      message = ERROR_MENTION
    } else {
      message = ERROR_REPLY
    }
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onClick = (event) => {
    event.stopPropagation()
  }

  return (
    <Status data-testid="error">
      {message}
      {isPermissionError && (
        <ErrorCTA
          href={URL_ACCOUNT_CHANNELS}
          data-testid="error-cta"
          onClick={onClick}
        >
          here.
        </ErrorCTA>
      )}
    </Status>
  )
}

/**
 *
 */
const Comment = ({
  // @ts-expect-error TS(7031) FIXME: Binding element 'comment' implicitly has an 'any' ... Remove this comment to see the full error message
  comment,
  // @ts-expect-error TS(7031) FIXME: Binding element 'channel' implicitly has an 'any' ... Remove this comment to see the full error message
  channel,
  // @ts-expect-error TS(7031) FIXME: Binding element 'selected' implicitly has an 'any'... Remove this comment to see the full error message
  selected,
  // @ts-expect-error TS(7031) FIXME: Binding element 'placeholder' implicitly has an 'a... Remove this comment to see the full error message
  placeholder,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onSelect' implicitly has an 'any'... Remove this comment to see the full error message
  onSelect,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onDismiss' implicitly has an 'any... Remove this comment to see the full error message
  onDismiss,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onUnDismiss' implicitly has an 'a... Remove this comment to see the full error message
  onUnDismiss,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onAddReply' implicitly has an 'an... Remove this comment to see the full error message
  onAddReply,
  // @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
  children,
}) => {
  const {
    text,
    // @ts-expect-error TS(2525) FIXME: Initializer provides no value for this binding ele... Remove this comment to see the full error message
    from: { username, isChannel } = {},
    createdAt,
    replies = [],
    error,
    labels,
    needsAttention,
    attachment,
  } = comment || {}

  // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
  const hasUnprocessedReplies = replies.find((el) => el.needsAttention)
  const [showReplies, setShowReplies] = useState(hasUnprocessedReplies)

  useEffect(() => {
    // We open replies automatically if needed but we only
    // close them manually.
    if (hasUnprocessedReplies) {
      setShowReplies(true)
    }
  }, [hasUnprocessedReplies])

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const toggleShowReplies = (event) => {
    event.stopPropagation()
    setShowReplies(!showReplies)
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'text' implicitly has an 'any' type.
  const onSubmit = (text, metadata) => {
    onAddReply(comment, text, metadata)
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onDismissComment = (event) => {
    event.stopPropagation()
    onDismiss(comment)
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onUnDismissComment = (event) => {
    event.stopPropagation()
    onUnDismiss(comment)
  }

  if (!comment || placeholder) {
    return (
      <CommentWrapper data-testid="placeholder" animated={placeholder}>
        <Column>
          <AvatarWrapper>
            <AvatarDefault placeholder={placeholder} />
          </AvatarWrapper>
        </Column>
        <Column expand>
          <TextPlaceholder width="100%" height="13px" />
          <TextPlaceholder width="60%" height="13px" />
        </Column>
      </CommentWrapper>
    )
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'label' implicitly has an 'any' type.
  const labelIndicators = labels.map((label) => (
    <Label type={label} key={label} />
  ))

  const { avatar, service } = channel || {}
  const commentStatus = getCommentStatus(comment, selected, service)

  const createdAgo = formatTimeAgo(createdAt, new Date())
  const repliesCount = replies.length
  const mightBeDeleted = error && error.code === ERROR_SEND_COMMENT_DELETED
  const disabled = !needsAttention || mightBeDeleted
  const displayError =
    error && error.type !== 'engageUnDismiss' && !selected && !mightBeDeleted

  return (
    <>
      <Wrapper
        selected={selected}
        disabled={disabled}
        error={error && !selected && !mightBeDeleted}
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        onClick={disabled ? null : () => onSelect(comment)}
        data-testid="comment"
      >
        <CommentWrapper animated={placeholder}>
          <Column>
            <AvatarWrapper>
              {isChannel ? (
                <ChannelAvatar image={avatar} />
              ) : (
                <AvatarDefault username={username} service={service} />
              )}
            </AvatarWrapper>
          </Column>
          <Column expand>
            <ContentWrapper>
              <StyledText type="p" data-testid="text">
                <Username data-testid="username">{username}</Username>
                {text}
              </StyledText>
              {attachment && (
                <Attachment type={attachment.type} url={attachment.url} />
              )}
              <CommentInfo>
                <TimeAgo data-testid="time-ago">{createdAgo}</TimeAgo>
                {!isChannel && (
                  <Status data-testid="status">{commentStatus}</Status>
                )}
                <Labels data-testid="labels">{labelIndicators}</Labels>
              </CommentInfo>
              {!isChannel && (
                <ToggleWrapper
                  data-testid={
                    needsAttention ? 'dismiss-button' : 'undismiss-button'
                  }
                >
                  <CommentToggle
                    pending={needsAttention}
                    onClick={
                      needsAttention ? onDismissComment : onUnDismissComment
                    }
                  />
                </ToggleWrapper>
              )}
            </ContentWrapper>
            <Row>
              {selected && (
                <ComposerWrapper>
                  <Composer
                    username={
                      channel?.service !== 'facebook' ? username : undefined
                    }
                    draft={error ? error.draft : ''}
                    onSubmit={onSubmit}
                    data-testid="composer"
                  />
                </ComposerWrapper>
              )}
              {repliesCount > 0 && (
                <ShowReplies
                  onClick={toggleShowReplies}
                  // @ts-expect-error TS(2769) FIXME: No overload matches this call.
                  opened={showReplies}
                  data-testid="replies-toggle"
                  overlay={selected}
                >
                  <ShowRepliesDecoration>---------------</ShowRepliesDecoration>
                  {showReplies ? 'Close replies' : 'View replies'} (
                  {repliesCount})
                </ShowReplies>
              )}
            </Row>
          </Column>
        </CommentWrapper>
        {displayError && (
          <ErrorWrapper>
            <ErrorIconWrapper>
              <WarningIcon />
            </ErrorIconWrapper>
            <Error error={error} />
          </ErrorWrapper>
        )}
      </Wrapper>
      <RepliesWrapper data-testid="replies">
        {repliesCount > 0 && showReplies && children}
      </RepliesWrapper>
    </>
  )
}

Comment.propTypes = {
  comment: PropTypes.object,
  channel: PropTypes.object,
  selected: PropTypes.bool,
  placeholder: PropTypes.bool,
  onSelect: PropTypes.func,
  onDismiss: PropTypes.func,
  onAddReply: PropTypes.func,
}

Comment.defaultProps = {
  comment: null,
  channel: null,
  selected: false,
  placeholder: false,
  onSelect: () => {},
  onDismiss: () => {},
  onAddReply: () => {},
}

export default Comment
